var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"19.59.0"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/saatchi-general";

import * as Sentry from '@sentry/nextjs'
import { BrowserTracing } from '@sentry/browser'
import { CaptureConsole } from '@sentry/integrations'
import { getCriticalPageInfo } from './lib/sentry/criticalPages'

const { APP_ENV, NODE_ENV } = process.env

// Set NEXT_PUBLIC_SENTRY_FORCE_ENABLED=true in .env to enable Sentry locally for testing
const isProd =
  NODE_ENV === 'production' ||
  APP_ENV === 'production' ||
  process.env.NEXT_PUBLIC_SENTRY_FORCE_ENABLED === 'true'

if (isProd) {
  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: APP_ENV || 'unknown',
    release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,

    //sampleRate: 1.0,
    sampleRate: 0.1,

    //tracesSampleRate: 0.1,
    tracesSampler: (samplingContext) => {
      const pathname = samplingContext.location?.pathname || ''
      const pageInfo = getCriticalPageInfo(pathname)
      return pageInfo ? 0.01 : 0
      //return pageInfo ? 0.25 : 0.05
    },

    // Replay: capture 10% of sessions, 100% when an error occurs
    //replaysSessionSampleRate: 0.1, disabled for now
    //replaysOnErrorSampleRate: 1.0, disabled for now

    integrations: [
      new BrowserTracing({
        tracePropagationTargets: ['localhost', /^https:\/\/www\.saatchiart\.com/, /^\/api/],
      }),
      //new Sentry.Replay(), disabled for now
      //new CaptureConsole({ levels: ['error', 'warn'] }),
    ],

    beforeSend(event, hint) {
      const pathname = window?.location?.pathname || ''
      const pageInfo = getCriticalPageInfo(pathname)

      if (!pageInfo) {
        return null
      }

      event.tags = {
        ...event.tags,
        critical_page: true,
        page_name: pageInfo,
      }

      event.contexts = {
        ...event.contexts,
        page: {
          pathname,
          url: window?.location?.href || '',
        },
      }

      return event
    },

    ignoreErrors: [
      // Random plugins/extensions
      'top.GLOBALS',
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'http://tt.epicplay.com',
      "Can't find variable: ZiteReader",
      'jigsaw is not defined',
      'ComboSearch is not defined',
      'http://loading.retry.widdit.com/',
      'atomicFindClose',
      // Facebook borked
      'fb_xd_fragment',
      // ISP "optimizing" proxy
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      'conduitPage',
      // Generic errors with no useful context
      'Script error.',
      'UnhandledRejection',
      // Browser extensions
      'chrome-extension',
      'moz-extension',
      // Network errors
      'NetworkError',
      'Failed to fetch',
      'Load failed',
      'ResizeObserver loop',
      // iOS WebView noise
      'window.webkit.messageHandlers',
      // Android WebView noise
      'Java object is gone',
      // Browser autofill injection
      '_AutofillCallbackHandler',
      // grecaptcha timing/network issue
      "Can't find variable: grecaptcha",
    ],

    denyUrls: [
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
      // Firefox extensions
      /^moz-extension:\/\//i,
      // Other plugins
      /127\.0\.0\.1:4001\/isrunning/i,
      /webappstoolbarba\.texthelp\.com\//i,
      /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
      // OneTrust cookie banner scripts
      /scripttemplates\//i,
      // Alby web components (third-party)
      /apps\/web-components\/alby-web-components\//i,
    ],
  })
}
